/**
 * 
 *   Usage: See clsList for examples, API and implementation notes. 
 * 
 */
import clsList from '@cls/clsList'
import string from '@lib/string'
 
class clsUnitList extends clsList {
 
     /**
     * Get the first found hour type.
     * We search - in order - for: 
     * 'uur', 'uren'
     * 
     * When not found, return null.
     * 
     * @param {} id 
     */
    getHourType() {
        for (let name of ['uur', 'uren']) {
            var unit = this.list.find( (v) => string.compare(v.name,name));
            if (unit) {
                return unit;
            }
        }
        return null;
    }
 }
 
export default clsUnitList
